import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import "./Footer.scss";

const Footer = () => {
  return (
    <>
      <div className="footer d-flex flex-row sm-fCol">
        <div className="flex-50 d-flex flex-column">
          <StaticImage
            src="../../images/star-logo.png"
            width={80}
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="star logo"
            objectFit="contain"
            objectPosition="left center"
          />
        </div>
        <div className="flex-50 d-flex flex-column nav">
          <p className="star">
            © S.T.A.R. Services Group 2020 ALL RIGHTS RESERVED
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
